(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dt-proposal-swiper"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dt-proposal-carousel')) {
  let swiperModule;
  const loadSwiper = () => swiperModule || (swiperModule = import('https://cdn.jsdelivr.net/npm/swiper@8.4.7/swiper-bundle.esm.browser.min.js').catch(error => { swiperModule = null; throw error; }));
  customElements.define('dt-proposal-carousel', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle = (this.lifecycle || 0) + 1;
      const lifecycle = this.lifecycle;
      this.onSelect = event => {
        const index = Array.from(this.querySelectorAll('.dt-proposal-slide:not(.swiper-slide-duplicate)')).findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0 || !this.slider) return;
        if (this.slider.params.loop) this.slider.slideToLoop(index, 0);
        else this.slider.slideTo(index, 0);
      };
      this.addEventListener('shopify:block:select', this.onSelect);
      // HTML cards remain readable and horizontally scrollable while the library loads.
      loadSwiper().then(({default: Swiper}) => {
        if (!this.isConnected || lifecycle !== this.lifecycle) return;
        const count = this.querySelectorAll('.dt-proposal-slide').length;
        const desktop = Number(this.dataset.desktop);
        const mobile = Number(this.dataset.mobile);
        const loop = count >= Math.ceil(Math.max(desktop, mobile, 2.6)) + 1;
        this.setAttribute('data-ready', '');
        this.slider = new Swiper(this.querySelector('.dt-proposal-viewport'), {
          wrapperClass: 'dt-proposal-track', slideClass: 'dt-proposal-slide',
          slidesPerView: mobile, spaceBetween: 16, slidesPerGroup: 1,
          loop, loopedSlides: count, centeredSlides: loop,
          centerInsufficientSlides: !loop, watchOverflow: true,
          speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500,
          breakpoints: {700: {slidesPerView: 2.6, spaceBetween: 20}, 1000: {slidesPerView: desktop, spaceBetween: Number(this.dataset.gap)}},
          navigation: {prevEl: this.querySelector('.dt-proposal-prev'), nextEl: this.querySelector('.dt-proposal-next')},
          a11y: {prevSlideMessage: '前のカード', nextSlideMessage: '次のカード', slideLabelMessage: '{{index}} / {{slidesLength}}'},
          on: {
            init: swiper => this.updateArrows(swiper),
            resize: swiper => this.updateArrows(swiper),
            breakpoint: swiper => this.updateArrows(swiper),
            lock: swiper => this.updateArrows(swiper),
            unlock: swiper => this.updateArrows(swiper)
          }
        });
      }).catch(error => {this.removeAttribute('data-ready'); console.warn('Proposal slider: horizontal-scroll fallback is active.', error);});
    }
    updateArrows(swiper) {
      const count = this.querySelectorAll('.dt-proposal-slide:not(.swiper-slide-duplicate)').length;
      this.querySelectorAll('.dt-proposal-arrow').forEach(button => {button.hidden = count <= Number(swiper.params.slidesPerView);});
    }
    disconnectedCallback() {
      this.lifecycle = (this.lifecycle || 0) + 1;
      this.removeEventListener('shopify:block:select', this.onSelect);
      if (this.slider) {this.slider.destroy(true, true); this.slider = null;}
      this.removeAttribute('data-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
